// 行数を絞って描く DataTable。
//
// 🔴 在庫分析の3表（評価額・ABC・滞留）はサーバー側に上限が無く、SPA も全行を
// そのまま描いていた＝Pro の商品上限（1万件）に近い店では、1画面で数万行を
// 生成して開けなくなる。3表とも**重要度の降順**（評価額・売上・寝ている資金）で
// 並んでいるので、先頭を残して打ち切れば「見たい部分」は失われない。
// 残りは「さらに表示」で足す＝隠したことを黙らない。
import { Button, Card, DataTable, InlineStack } from "@shopify/polaris";
import { useState } from "react";

import { t } from "../lib/i18n";

/** 一度に描く行数と、「さらに表示」1回で増える行数。 */
export const DEFAULT_ROW_STEP = 50;

interface CappedDataTableProps {
  columnContentTypes: React.ComponentProps<typeof DataTable>["columnContentTypes"];
  headings: React.ComponentProps<typeof DataTable>["headings"];
  rows: React.ComponentProps<typeof DataTable>["rows"];
  step?: number;
}

export function CappedDataTable({
  columnContentTypes,
  headings,
  rows,
  step = DEFAULT_ROW_STEP,
}: CappedDataTableProps) {
  const [shownCount, setShownCount] = useState(step);
  const shownRows = rows.slice(0, shownCount);
  const hiddenCount = rows.length - shownRows.length;

  return (
    <Card padding="0">
      <DataTable
        columnContentTypes={columnContentTypes}
        headings={headings}
        rows={shownRows}
      />
      {hiddenCount > 0 && (
        <div style={{ padding: "var(--p-space-300)" }}>
          <InlineStack align="center">
            <Button onClick={() => setShownCount((n) => n + step)}>
              {t("さらに表示（残り {n} 件）", { n: hiddenCount })}
            </Button>
          </InlineStack>
        </div>
      )}
    </Card>
  );
}
